import { createSlice } from "@reduxjs/toolkit";

const IssuerSlice = createSlice({
    name: "Issuers",
    initialState:{
        items:[]
    },
    reducers:{
        addIssuers:(state, action)=>{
            state.items.push(action.payload)
        },

        updateIssuer:(state, action)=>{
            return{
                ...state,
                items:{
                    ...state.items,
                    ...action.payload

                }
            }

        }
    }
})

export const {addIssuers} = IssuerSlice.actions;

export default IssuerSlice.reducer;